import { render, staticRenderFns } from "./PopUpModal.vue?vue&type=template&id=4bfb9602&scoped=true&"
import script from "./PopUpModal.vue?vue&type=script&lang=ts&"
export * from "./PopUpModal.vue?vue&type=script&lang=ts&"
import style0 from "./PopUpModal.vue?vue&type=style&index=0&id=4bfb9602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfb9602",
  null
  
)

export default component.exports